(() => {
  if (customElements.get('project-kickstart-popup')) return;

  class ProjectKickstartPopup extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.closeButton = this.querySelector('[data-project-kickstart-close]');
      this.cta = this.querySelector('[data-project-kickstart-cta]');
      this.campaignId = this.dataset.campaignId || 'project-kickstart';
      this.delay = Math.max(0, Number(this.dataset.delaySeconds) || 0) * 1000;
      this.dismissDays = Math.max(0, Number(this.dataset.dismissDays) || 0);
      this.storageKey = `flexikitchPopup:${this.campaignId}`;
      this.handleClose = () => this.close('button');
      this.handleKeydown = (event) => {
        if (event.key === 'Escape' && this.isVisible()) this.close('escape');
      };
      this.handleCta = () => this.track('click');
      this.handleSectionSelect = (event) => {
        if (event.target.contains(this)) this.show(false);
      };

      this.closeButton?.addEventListener('click', this.handleClose);
      this.cta?.addEventListener('click', this.handleCta);
      document.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('shopify:section:select', this.handleSectionSelect);

      if (window.Shopify?.designMode) {
        this.show(false);
        return;
      }

      if (!this.isDismissed()) {
        this.showTimer = window.setTimeout(() => this.tryShow(), this.delay);
      }
    }

    disconnectedCallback() {
      window.clearTimeout(this.showTimer);
      window.clearTimeout(this.hideTimer);
      this.closeButton?.removeEventListener('click', this.handleClose);
      this.cta?.removeEventListener('click', this.handleCta);
      document.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('shopify:section:select', this.handleSectionSelect);
    }

    tryShow(attempt = 0) {
      const activeModal = document.querySelector('.modal[aria-hidden="false"]');

      if (activeModal && attempt < 20) {
        this.showTimer = window.setTimeout(() => this.tryShow(attempt + 1), 1000);
        return;
      }

      this.show(true);
    }

    show(trackView = true) {
      if (this.isVisible()) return;

      window.clearTimeout(this.hideTimer);
      this.hidden = false;
      window.requestAnimationFrame(() => this.classList.add('is-visible'));

      if (trackView && !this.viewTracked) {
        this.viewTracked = true;
        this.track('view');
      }
    }

    close(reason) {
      if (!this.isVisible()) return;

      this.classList.remove('is-visible');
      this.rememberDismissal();
      this.track('dismiss', { reason });
      this.hideTimer = window.setTimeout(() => {
        this.hidden = true;
      }, 380);
    }

    isVisible() {
      return !this.hidden && this.classList.contains('is-visible');
    }

    isDismissed() {
      try {
        const dismissalExpires = Number(window.localStorage.getItem(this.storageKey));

        if (!dismissalExpires) return false;
        if (dismissalExpires > Date.now()) return true;

        window.localStorage.removeItem(this.storageKey);
      } catch (error) {
        return false;
      }

      return false;
    }

    rememberDismissal() {
      if (window.Shopify?.designMode) return;

      try {
        const duration = this.dismissDays * 24 * 60 * 60 * 1000;
        window.localStorage.setItem(this.storageKey, String(Date.now() + duration));
      } catch (error) {
        return;
      }
    }

    track(action, details = {}) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: `project_kickstart_popup_${action}`,
        campaign_id: this.campaignId,
        ...details
      });
    }
  }

  customElements.define('project-kickstart-popup', ProjectKickstartPopup);
})();
